// extracted by extract-css-chunks-webpack-plugin
module.exports = {"user-wrapper":"_1fqNE","userWrapper":"_1fqNE","avatar":"_3sC78","name":"_2QDLO","position":"_3U8K-"};